/** @format */

import { useCallback, useEffect, useState, type ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Header } from '../header';
import { Footer } from '../footer';
import useAuth from 'src/hooks/useAuth';
import { resolveSelectedLanguage, setAppLanguage } from 'src/utils/locale';
import { ONBOARDING_PAGE_ID } from 'src/constants';

type DefaultLayoutProps = {
  children?: ReactNode;
};

const DefaultLayout = (props: DefaultLayoutProps) => {
  const { isAuthenticated, user, error } = useAuth();
  const [userLang, setLang] = useState<string | undefined>();
  const navigate = useNavigate();
  const location = useLocation();
  const onboardingPath = `/page/${ONBOARDING_PAGE_ID}`;

  useEffect(() => {
    if (
      user &&
      (user.onBoardingComplete === false || user.onBoardingComplete === undefined) &&
      location.pathname !== onboardingPath
    ) {
      navigate(onboardingPath);
    }
  }, [user, location.pathname, onboardingPath, navigate]);

  useEffect(() => {
    setLang(resolveSelectedLanguage());
  }, [user]);

  const getSelectLang = useCallback(async (e: { target?: { value?: string } }) => {
    const value = e?.target?.value;
    if (!value) {
      return;
    }

    const lang = await setAppLanguage(value, { manual: true });
    setLang(lang);
    const url = new URL(window.location.href);
    url.searchParams.set('language', lang);
    window.location.assign(url.toString());
  }, []);

  return (
    <>
      <section className="main_section">
        <Header getSelectLang={getSelectLang} userLang={userLang} />

        <div className="content">{(isAuthenticated || error) && props.children}</div>

        <Footer />
      </section>
    </>
  );
};

export { DefaultLayout };
